module.exports = __webpack_public_path__ + "static/media/b_logo_blanco.e4479a48.png";